export default "__VITE_ASSET__C3xSEwki__"